/**
 * affiliate Affiliate Management JS
 *
 * @copyright 2013, Aussie Sim
 *
 * @version 1.00
 * @author Simplisite <developer@simplisite.com.au>
 */
function Documents() {
    return {
        theGridView: false,
        /**
         * Init
         */
        init: function() {
            var self = this;

            //add the grid
            this.createGridView();

            $('#search-form').submit(function() {
                self.reload();
                return false;
            });
        },

        /**
         * Generate and store a reference to a new KendoGrid
         */
        createGridView: function() {
            // Set grid height
            $('#documents-grid').height((window.innerHeight - 60) * 0.8);
            if (typeof window.documentsGrid !== 'undefined') {
                $('#documents-grid').kendoGrid({
                    dataSource: window.documentsGrid,
                    filterable: true,
                    sortable: true,
                    pageable: true,
                    pageable: {
                        pageSize: 10
                    },
                    dataBound: function(e) {
                        $('#documents-grid .edit-btn').click(function() {
                            window.location =
                                '/' +
                                URLSEGMENT +
                                '/editaffiliatedocument/' +
                                $(this).attr('data-record-id') +
                                '/?rm=filedownloads';
                            return false;
                        });
                    },
                    columns: [
                        {
                            field: 'Title',
                            title: 'Title',
                            width: '200px'
                        },
                        {
                            field: 'Summary',
                            title: 'Summary',
                            width: '200px'
                        },
                        {
                            field: 'GetSize',
                            title: 'Size',
                            width: '125px'
                        },
                        {
                            field: 'VersionNumber',
                            title: 'Version Date',
                            width: '200px'
                        },
                        {
                            filterable: false,
                            title: '',
                            width: '200px',
                            template:
                                '# if (CanCurrentAffiliateEdit == 1) {# ' +
                                '<a href="" id="deactivate-document-${ ID }" data-record-id="${ ID }" class="btn btn-small btn-primary btn-slim edit-btn">Edit</a>' +
                                '#} else {# ' +
                                '<a href="${ Link }" id="deactivate-document-${ ID }" data-record-id="${ ID }" class="btn btn-small btn-primary btn-slim">Download</a>  ' +
                                '#}#'
                        }
                    ]
                });

                this.theGridView = $('#documents-grid').data('kendoGrid');
            }
        },

        /**
         * Refresh the insights dashboard (usually called after the drop-downs are changed)
         */
        reload: function() {
            //reload the chart
            if (this.theGridView) {
                this.theGridView.dataSource.read();
                this.theGridView.refresh();
            }
        },

        /**
         * Resize Handler
         */
        onresize: function(e) {
            if ($('#documents-grid').length && $('#documents-grid').data('kendoGrid')) {
                $('#documents-grid').height((window.innerHeight - 60) * 0.8);
                $('#documents-grid')
                    .data('kendoGrid')
                    .refresh();
            }
        }
    };
}

/**
 * Initialise
 */
var SC;
$(document).ready(function() {
    SC = new Documents();

    SC.init();

    window.onresize = SC.onresize;
});
